import { Component, OnInit } from '@angular/core';
import { AuthAndACLService } from '../auth_and_acl/authAndACL.service';
import { URL_API } from './../constante';

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.css']
})
export class LogoutComponent implements OnInit {

  public manualurl: string;

  constructor(public authAndACL: AuthAndACLService) {
    this.manualurl = URL_API + "/manual/manual-scd.pdf";
  }

  logout(): void{
    this.authAndACL.logout();
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/logout/logout.component.ts